/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { getVignettes } from "../../../actions";
import Scrollbars from "react-custom-scrollbars";
import moment from "moment";
import { connect } from "react-redux";
import Statistics from "../../Statistics";

const headerElements = [
  {
    name: "User",
    query: { filter: "Date", options: [] },
  },
  {
    name: "Phone",
    query: { filter: "Time", options: [] },
  },
  {
    name: "Payment date",
    query: { filter: "Invitation sent by", options: [] },
  },
  {
    name: "Amount",
    query: { filter: "Role", options: [] },
  },
];

const Vignettes = ({ getVignettes, vignettes, period, filtered }) => {
  const [curPage, setCurPage] = useState(2);
  const tableRef = useRef();
  const [innerLoading, setInnerLoading] = useState(false);

  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values; //get elements from object
    const pad = 0; // how much px from bottom
    const t = (Math.round(scrollTop) + pad) / (scrollHeight - clientHeight); // must be at least 1.0
    if (t >= 0.97 && vignettes.totalPages >= curPage && !innerLoading) {
      setInnerLoading(true);
      getVignettes({
        pageNumber: curPage,
        limit: 20,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        onSuccess: (res) => setInnerLoading(false),
      });
      setCurPage(curPage + 1);
    }
  };

  useEffect(() => {
    getVignettes({
      pageNumber: 1,
      limit: 20,
      ...period,
      createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
    });
    setCurPage(2);
  }, []);

  useEffect(() => {
    if (filtered) {
      getVignettes({
        pageNumber: 1,
        limit: 20,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
      });
      setCurPage(2);
    }
  }, [period, filtered]);

  return (
    <>
      <h2 style={{ marginBottom: "20px", textTransform: "uppercase" }}>Users with purchased Vignettes</h2>
      <Scrollbars style={{ height: "92%", width: window.innerWidth < 1200 ? "160%" : "100%" }} onUpdate={handleUpdate} ref={tableRef} id={"scrollbar"} renderView={(props) => <div {...props} style={{ ...props.style, overflowX: "hidden" }} />}>
        <div className="table-header">
          {headerElements?.map((header, i) => {
            return (
              <div
                className="header-cont"
                key={i}
                style={{
                  width: "12%",
                }}
              >
                <div className="header">{header.name}</div>
              </div>
            );
          })}
        </div>
        {vignettes?.docs?.map((fine, i) => {
          return (
            <div className="table-body-row" key={i}>
              <div className="row-data" style={{ width: "12%" }}>
                {fine?.fullName || "---"}
              </div>
              <div className="row-data" style={{ width: "12%" }}>
                {fine?.phoneNumber || "---"}
              </div>
              <div className="row-data" style={{ width: "12%" }}>
                {moment(fine?.createdAt).format("DD.MM.YYYY") || "---"}
              </div>
              <div className="row-data" style={{ width: "12%" }}>
                {fine?.amount + "€" || "---"}
              </div>
            </div>
          );
        })}
        {innerLoading && (
          <div className="inner-loader-container">
            <Statistics.LoaderInline center />
          </div>
        )}
      </Scrollbars>
    </>
  );
};
const mapStateToProps = (state) => ({
  vignettes: state.app.vignettes,
});
const mapDispatchToProps = (dispatch) => ({
  getVignettes: (payload) => dispatch(getVignettes(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Vignettes);
